<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';

defineProps({
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
});
const emit = defineEmits<{
  (event: 'please-reset'): void;
  (event: 'do-no-reset'): void;
}>();

const { t } = useI18n({ useScope: 'global' });

const title = computed(() => t('modules.charting.resetColorScheme.title'));
const message = computed(() => t('modules.charting.resetColorScheme.message'));
</script>

<template>
  <x-modal
    class="reset-color-change-modal"
    :variant="variant"
    :title="title"
    type="base"
  >
    <template #content>
      <p>{{ message }}</p>
    </template>
    <template #buttons>
      <x-button
        ref="ok"
        variant="outline"
        :text="$t('modules.charting.resetColorScheme.button.restore')"
        @click="emit('please-reset')"
      />
      <x-button
        ref="ok"
        variant="primary"
        :text="$t('modules.charting.resetColorScheme.button.keep')"
        @click="emit('do-no-reset')"
      />
    </template>
  </x-modal>
</template>
